<template>
  <div class='animated fadeIn'>
    <div class='app flex-row align-items-center'>
      <b-container>
        <b-row class='justify-content-center'>
          <b-col>
            <b-card-group>
              <b-card>
                <b-card-body body-bg-variant='white'>
                  <h1>ログイン</h1>
                  <p>ログインまたは新規登録により本サービスの<router-link to='Terms'>利用規約</router-link> & <router-link to='Privacy'>プライバシーポリシー</router-link>に同意したものとします。</p>
                  <p>登録済みアカウントにログインします。<font color="#ff0000">（未登録の方は、新規登録をお願いします）</font></p>
                  <b-form>
                    <el-input class='mb-3' size='medium' type='text' placeholder='エントリーコード' name='entrycode' v-model='input.entryCode'>
                      <template slot="prepend"><i class="fas fa-passport"></i></template>
                    </el-input>
                    <el-input class='mb-3' size='medium' type='email' placeholder='メールアドレス' name='username' v-model='input.username' autocomplete='username email'>
                      <template slot="prepend"><i class="fas fa-envelope"></i></template>
                    </el-input>
                    <el-input class='mb-3' size='medium' type='password' placeholder='パスワード' name='password' v-model='input.password' autocomplete='current-password'>
                      <template slot="prepend"><i class="fas fa-unlock-alt"></i></template>
                    </el-input>
                    <b-row class='mb-4'>
                      <b-col cols='6'>
                        <b-button variant='primary' class='px-4' v-on:click='login()'>Login</b-button>
                      </b-col>
                      <b-col cols='6' class='text-right'>
                        <!-- <b-button variant='link' class='px-0' v-on:click='passwordReset()'>Forgot password?</b-button> -->
                        <b-btn class='submit-btn px-0' variant='link' v-b-modal.modal-center>Forgot password?</b-btn>
                        <b-modal v-if='input.username' id='modal-center'
                                ref='modal'
                                title='パスワードリセット'
                                @ok='passwordReset'
                                centered
                                header-bg-variant='danger'
                                body-text-variant='danger'
                                ok-variant='danger'
                                size='sm'
                                class='px100-btn'
                                style='text-align:left;'>
                          <p>パスワードを再設定する案内を {{ input.username }} へ送信します</p>
                          <p>よろしいですか?</p>
                        </b-modal>
                        <b-modal v-else id='modal-center'
                                ref='modal'
                                title='エラー'
                                :ok-only='true'
                                centered
                                header-bg-variant='danger'
                                body-text-variant='danger'
                                ok-variant='danger'
                                size='sm'
                                class='px100-btn'
                                style='text-align:left;'>
                          <p>パスワードを再設定する案内を送信するメールアドレスを入力してください</p>
                        </b-modal>
                      </b-col>
                    </b-row>
                    <b-modal ref='errorModal'
                      centered title='エラー'
                      class='text-danger'
                      :ok-only='true'
                      ok-variant=danger
                      header-bg-variant=danger
                      size='sm'>
                      <p class='my-4'>{{errorMessage}}</p>
                    </b-modal>
                    <b-row>
                      <b-col cols='12'>
                      <h6><font color="#ff0000">（注意） Facebookおよび Googleによるログインは、2021年6月30日以降、利用出来なくなります。</font></h6>
                      </b-col>
                    </b-row>
                    <b-row class='mb-2'>
                      <b-col cols='12'>
                        <b-button block class='btn btn-facebook' v-on:click='facebook()'><i class="fab fa-facebook-f"></i><span> facebook</span></b-button>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols='12'>
                        <b-button block class='btn btn-social btn-gplus' type='button' v-on:click='google()'><i class="fab fa-google"></i><span> Google</span></b-button>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-card-body>
              </b-card>
              <b-card lass='text-white bg-primary'>
                <b-card-body class='text-center' body-bg-variant='white'>
                    <h1>新規登録</h1>
                    <p>Googleアカウントをお持ちでない方はこちらから新規に登録をお願いします。</p>
                    <b-button variant='primary' v-on:click='registerButton' class='active mt-3'>今すぐ登録！</b-button>
                </b-card-body>
              </b-card>
            </b-card-group>
            <b-card-footer>
              <p style="text-align: center;">本サービスのご利用には、<a href="https://www.google.com/chrome/" target="blank">Google Chrome</a>ブラウザをお使いください <font color="#ff0000">（* Internet Explorerには対応しておりません）</font></p>
            </b-card-footer>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import { mapGetters } from 'vuex'
export default {
  name: 'Login',
  data () {
    return {
      input: {
        entryCode: '',
        username: '',
        password: ''
      },
      errorTitle: '',
      errorMessage: '',
      service: null,
      inprogress: false,
      unwatch: null
    }
  },
  beforeDestroy () {
  },
  created () {
  },
  computed: {
    ...mapGetters({
      loading: 'dispatch/loading',
      services: 'service/services',
      init: 'authUser/init',
      auth: 'dispatch/auth',
      register: 'register/register',
      authUser: 'authUser/user'
    })
  },
  methods: {
    showModal () {
      this.$refs.errorModal.show()
    },
    hideModal () {
      this.$refs.errorModal.hide()
    },
    checkEntry () {
      if (this.input.entryCode.length < 1) {
        return -1
      }
      this.service = null
      const index = this.services.findIndex(service => service.entryCode === this.input.entryCode)
      if (index !== -1) {
        this.service = JSON.parse(JSON.stringify(this.services[index]))
      }
      return index
    },
    registerWithService (provider) {
      return new Promise((resolve, reject) => {
        var vm = this
        var user = firebase.auth().currentUser
        const db = firebase.firestore()
        const settings = { timestampsInSnapshots: true }
        db.settings(settings)
        var docRef = db.collection('users').doc(user.uid)
        docRef.get().then(function (doc) {
          if (!doc.exists) {
            var service = {}
            var role = 'user'
            if (vm.services.length !== 0) {
              service[vm.service.key] = true
            } else {
              role = 'admin'
            }
            var photo = user.photoURL
            if (provider === 'facebook') {
              photo = photo + '?width=512&height=512'
            }
            const payload = {
              'key': user.uid,
              'role': role,
              'services': service,
              'groups': {},
              'name': user.displayName,
              'email': user.email,
              'status': '',
              'icon': photo,
              'routine': [],
              'enable': true,
              'option': {},
              'createdAt': parseInt(new Date().getTime() / 1000),
              'updatedAt': parseInt(new Date().getTime() / 1000)
            }
            const batch = db.batch()
            var refuser = db.collection('users').doc(user.uid)
            batch.set(refuser, payload)

            if (vm.services.length !== 0) {
              var refChatsRefFrom = db.collection('chats_refs').doc(vm.service.key).collection('refs').doc(user.uid)
              batch.set(refChatsRefFrom,
                {
                  'location': vm.service.chats_ref,
                  'type': 'service',
                  'status': 'pending',
                  'enable': false,
                  'createdAt': parseInt(new Date().getTime() / 1000),
                  'updatedAt': parseInt(new Date().getTime() / 1000)
                }
              )
              var refChatsRefTo = db.collection('chats_refs').doc(user.uid).collection('refs').doc(vm.service.key)
              batch.set(refChatsRefTo,
                {
                  'location': vm.service.chats_ref,
                  'type': 'service',
                  'status': 'requesting',
                  'enable': false,
                  'createdAt': parseInt(new Date().getTime() / 1000),
                  'updatedAt': parseInt(new Date().getTime() / 1000)
                }
              )
            }
            batch.commit().then(function () {
              var serviceRef = db.collection('services').doc(vm.service.key)
              return db.runTransaction(function (transaction) {
                return transaction.get(serviceRef).then(function (doc) {
                  if (doc.exists) {
                    var service = JSON.parse(JSON.stringify(doc.data()))
                    service.users[user.uid] = true
                    service.updatedAt = parseInt(new Date().getTime() / 1000)
                    transaction.update(serviceRef, service)
                  }
                }).then(function () {
                  resolve()
                }).catch(function (error) {
                  console.log('transaction:', error)
                  resolve()
                })
              })
              // vm.$router.go(-1)
            })
          } else {
            resolve()
          }
        })
      })
    },
    login () {
      var vm = this
      if (this.services.length !== 0 && this.checkEntry() === -1) {
        this.errorMessage = '正しいエントリーコードを入力してください。ご不明な場合は、担当までお問い合わせください'
        this.showModal()
        return
      }
      if (this.input.username === '') {
        this.errorMessage = '登録済みのメールアドレスを入力してください'
        this.showModal()
        return
      }
      if (this.input.password !== '') {
        firebase.auth().signInWithEmailAndPassword(this.input.username, this.input.password).then(function (result) {
          vm.onLoading()
          vm.$store.dispatch('dispatch/setLoading', true)
          vm.registerWithService('password').then(() => {
            vm.$router.push('/')
            vm.$store.dispatch('register/register', true)
          })
        }).catch(function (error) {
          vm.errorMessage = error.message
          vm.showModal()
        })
      } else {
        this.errorMessage = '登録済みのパスワードをを入力してください'
        this.showModal()
      }
    },
    google () {
      var vm = this
      if (this.checkEntry() !== -1) {
        var provider = new firebase.auth.GoogleAuthProvider()
        firebase.auth().signInWithPopup(provider).then(function (result) {
          vm.onLoading()
          vm.$store.dispatch('dispatch/setLoading', true)
          vm.registerWithService('google').then(() => {
            vm.$router.push('/')
            vm.$store.dispatch('register/register', true)
          })
        }).catch(function (error) {
          vm.errorMessage = error.message
          vm.showModal()
        })
      } else {
        this.errorMessage = '正しいエントリーコードを入力してください。ご不明な場合は、担当までお問い合わせください'
        this.showModal()
      }
    },
    facebook () {
      var vm = this
      if (this.checkEntry() !== -1) {
        var provider = new firebase.auth.FacebookAuthProvider()
        firebase.auth().signInWithPopup(provider).then(function (result) {
          vm.onLoading()
          vm.$store.dispatch('dispatch/setLoading', true)
          vm.registerWithService('facebook').then(() => {
            vm.$router.push('/')
            vm.$store.dispatch('register/register', true)
          })
        }).catch(function (error) {
          vm.errorMessage = error.message
          vm.showModal()
        })
      } else {
        this.errorMessage = '正しいエントリーコードを入力してください。ご不明な場合は、担当までお問い合わせください'
        this.showModal()
      }
    },
    registerButton () {
      this.$router.push('register')
    },
    passwordReset () {
      var vm = this
      var auth = firebase.auth()
      auth.languageCode = 'ja'
      var emailAddress = this.input.username
      auth.sendPasswordResetEmail(emailAddress).then(function () {
      }).catch(function (error) {
        vm.errorMessage = error.message
        vm.showModal()
      })
    }
  }
}
</script>

<style lang='scss'>
.btn-gplus {
    background-color: #dd4b39;
    color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue